import { useForm } from "react-hook-form";
import Form from "../../interface/Form";
import FormRow from "../../interface/FormRow";
import Input from "../../interface/Input";
import Button from "../../interface/Button";
import { useSearchParams } from "react-router-dom";
import { useUpdateExtended } from "./useUpdateExtended";
import { useGetExtended } from "./useGetExtended";
import { useEffect } from "react";

function CompetencyList() {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();
  const [searchParams] = useSearchParams();
  const employeeId = searchParams.get("id");
  const { mutate: updateExtended } = useUpdateExtended();
  const { data, isLoading, isError } = useGetExtended(employeeId);

  useEffect(() => {
    // Clear form when starting a new query or when an error occurs
    if (isLoading || isError) {
      reset(); // Resets to initial form state or you can pass specific values to reset to
    }
  }, [employeeId, isLoading, isError, reset]);

  useEffect(() => {
    // Check if data has been fetched successfully and contains the competency information
    if (data && data.data.competencyGeneral && !isLoading && !isError) {
      const deserializedCompetencyInfo = JSON.parse(
        data.data.competencyGeneral
      );
      // Populate form fields with the fetched competency data
      Object.keys(deserializedCompetencyInfo).forEach((key) => {
        setValue(key, deserializedCompetencyInfo[key]);
      });
    }
  }, [data, isLoading, isError, setValue]);

  const onSubmit = (data) => {
    // Ensure employeeId is not null or undefined
    if (!employeeId) {
      console.error("Employee ID is missing.");
      return;
    }
    const userData = {
      id: employeeId,
      competencyGeneral: JSON.stringify(data),
    };
    updateExtended(userData);
    console.log("Submitted: ", userData);
    // Submit or process the data as needed
  };

  return (
    <Form type="modal" onSubmit={handleSubmit(onSubmit)}>
      <FormRow label="Technical Skill 1">
        <Input type="text" {...register("techSkill1")} />
      </FormRow>
      <FormRow label="Technical Skill 2 (Yes/No)">
        <Input type="checkbox" {...register("techSkill2")} />
      </FormRow>
      <FormRow label="Technical Skill 3 Rating">
        <Input type="range" min="0" max="5" {...register("techSkill3")} />
      </FormRow>
      <FormRow label="Technical Skill 4 (Yes/No)">
        <Input type="checkbox" {...register("techSkill4")} />
      </FormRow>
      <FormRow label="Technical Skill 5 Rating">
        <Input type="range" min="0" max="5" {...register("techSkill5")} />
      </FormRow>
      <FormRow label="Technical Skill 6">
        <Input type="text" {...register("techSkill6")} />
      </FormRow>
      <FormRow label="Technical Skill 7 (Yes/No)">
        <Input type="checkbox" {...register("techSkill7")} />
      </FormRow>
      <FormRow label="Technical Skill 8 (Yes/No)">
        <Input type="checkbox" {...register("techSkill8")} />
      </FormRow>
      <FormRow label="Technical Skill 9 Rating">
        <Input type="range" min="0" max="5" {...register("techSkill9")} />
      </FormRow>
      <FormRow label="Technical Skill 10 (Yes/No)">
        <Input type="checkbox" {...register("techSkill10")} />
      </FormRow>
      <FormRow label="Technical Skill 11 Rating">
        <Input type="range" min="0" max="5" {...register("techSkill11")} />
      </FormRow>
      <FormRow label="Technical Skill 12">
        <Input type="text" {...register("techSkill12")} />
      </FormRow>
      <Button type="submit">Update Info</Button>
    </Form>
  );
}

export default CompetencyList;
